/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable sonarjs/cognitive-complexity */
import { useMsal } from "@azure/msal-react";
import { parseISO } from "date-fns";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import moment from "moment";

import { axiosDelRequest, axiosGetRequest } from "../../api/ApiClient";
import Dialog from "../../components/Dialog";
import DialogMessage from "../../components/DialogMessage";
import { CalendarIcon, DeleteIcon, EditIcon } from "../../components/Icons";
import HolidayParams from "../../model/HolidayParams";
import ModalCallback from "../../model/ModalCallback";
import IModalProps from "../../model/ModalProps";
import ButtonStyles from "../../styles/components/ButtonStyles";
import DialogStyles from "../../styles/components/DialogStyles";
import GenericUtils from "../../utils/GenericUtils";
import StringUtils from "../../utils/types/StringUtils";
import ModalSaveHoliday from "./ModalSaveHoliday";
import ActivityManagementService from "../../service/Docente/ActivityManagementDateService";
import { StyledCenterDiv } from "../../styles/MainStyles";
import { IActivityManagementDetails } from "../../model/Calendar";
import ModalInfoManagementActivity from "./ModalInfoManagementActivity";
import DateUtils from "../../utils/DateUtils";

const { BtnPrimary, DefaultButtonLink } = ButtonStyles;
const { StyledContainerButton } = DialogStyles;

interface IModalDetailHolidayProps extends IModalProps {
    idHoliday?: number;
    params?: HolidayParams[];
    type?: string;
    readonly: boolean;
}

const initialActivityManagementDetails: IActivityManagementDetails = {
    id: 0,
    referenceStartDate: null,
    referenceEndDate: null,
    justificationEndDate: null,
    approvalEndDate: null,
    insertedPersonRegistration: "",
    insertedPersonName: "",
    updatedAt: null,
    isLoaded: false,
};

const ModalDetailHoliday: React.FC<IModalDetailHolidayProps> = ({
    idHoliday,
    params,
    type,
    open,
    visibility,
    onClose,
    readonly = true,
}) => {
    const { instance } = useMsal();
    const acessToken = GenericUtils.getAccessTokenDocente();

    const translate = {
        operationFailure: StringUtils.translate("operationFailure"),
        operationSuccess: StringUtils.translate("operationSuccess"),
    };

    const [holiday, setHoliday] = useState<HolidayParams>({} as HolidayParams);
    const [datesHoliday, setDatesHoliday] = useState<any>(null);
    const [showDialog, setShowDialog] = useState(visibility ?? true);
    const [openModalSaveHoliday, setOpenModalSaveHoliday] = useState(false);
    const [openDialogQuestionDelete, setOpenDialogQuestionDelete] =
        useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [abono, setAbono] = useState(null);
    const [showInfoManagement, setShowInfoManagement] = useState(false);
    const [activityManagementDetails, setActivityManagementDetails] =
        useState<IActivityManagementDetails>(initialActivityManagementDetails);

    const messageSuccess = "Parâmetro excluído";
    const dateFormat = "DD/MM/YYYY HH:mm";
    const dateResponseFormat = "YYYY-MM-DD HH:mm";

    const deleteHoliday = async () => {
        if (type === "ABONO_ADMINISTRACAO") {
            const response = await axiosDelRequest(
                `/docente/v1/calendarioabonoadministracoes/${idHoliday}`,
                acessToken,
                instance
            );
            if (GenericUtils.isSuccessStatus(response.status)) {
                setSuccessMessage(messageSuccess);
                setShowDialog(false);
            } else {
                setErrorMessage(
                    response.data?.details || translate.operationFailure
                );
            }
        } else if (type === "GESTAO_ATIVIDADES") {
            const response =
                await ActivityManagementService.deleteActivityManagementDate(
                    idHoliday,
                    instance
                );

            if (GenericUtils.isSuccessStatus(response.status)) {
                setSuccessMessage(messageSuccess);
                setShowDialog(false);
            } else {
                setErrorMessage(
                    response.data?.details || translate.operationFailure
                );
            }
        } else {
            const response = await axiosDelRequest(
                `/docente/v1/feriados/${holiday.id}`,
                acessToken,
                instance
            );
            if (GenericUtils.isSuccessStatus(response.status)) {
                setSuccessMessage(messageSuccess);
                setShowDialog(false);
            } else {
                setErrorMessage(
                    response.data?.details || translate.operationFailure
                );
            }
        }
    };

    const handleCloseModalSaveHoliday = (_callback?: ModalCallback) => {
        setOpenModalSaveHoliday(false);
        setShowDialog(visibility ?? true);
        setHoliday({} as HolidayParams);
        setDatesHoliday(null);
        setAbono(null);
        setActivityManagementDetails(initialActivityManagementDetails);
        if (onClose) onClose({ success: true });
    };

    const handleCloseDialogQuestionDelete = (callback: any) => {
        setOpenDialogQuestionDelete(false);
        setShowDialog(visibility ?? true);
        if (callback?.confirmButton && onClose) deleteHoliday();
    };

    const handleCloseDialogSuccess = () => {
        setSuccessMessage("");
        setShowDialog(visibility ?? true);
        setOpenModalSaveHoliday(false);
        if (onClose) onClose({ success: true });
    };

    const handleCloseDialogError = () => {
        setErrorMessage("");
        setShowDialog(visibility ?? true);
    };

    const handleCloseModalInformation = () => {
        setShowInfoManagement(false);
        setShowDialog(visibility ?? true);
    };

    useEffect(() => {
        async function getData() {
            if (open) {
                if (type === "ABONO_ADMINISTRACAO") {
                    const response = await axiosGetRequest(
                        `/docente/v1/calendarioabonoadministracoes/${idHoliday}`,
                        acessToken,
                        instance
                    );

                    if (response) {
                        const tempHoliday: any = {
                            id: response.data?.calendarioId,
                            type: "Abono",
                            campus: response.data?.campus?.id,
                            title: response.data?.nome,
                            date: response?.data.data,
                            color: "#2F6A99",
                        };
                        if (tempHoliday?.date) {
                            setDatesHoliday(
                                parseISO(tempHoliday?.date).toLocaleDateString(
                                    "pt-BR",
                                    {
                                        weekday: "long",
                                        month: "long",
                                        day: "numeric",
                                    }
                                )
                            );
                        }
                        setHoliday(tempHoliday);
                        setAbono(response.data);
                    }
                } else if (type === "GESTAO_ATIVIDADES") {
                    const response =
                        await ActivityManagementService.getActivityManagementDateById(
                            idHoliday,
                            instance
                        );

                    if (GenericUtils.isSuccessStatus(response.status)) {
                        const newActivityManagementDateDetails: IActivityManagementDetails =
                            {
                                id: response.data?.calendarioGestaoAtividadesId,
                                referenceStartDate: new Date(
                                    moment(
                                        response.data?.periodoInicioReferencia
                                    ).format(dateResponseFormat)
                                ),
                                referenceEndDate: new Date(
                                    moment(
                                        response.data?.periodoFimReferencia
                                    ).format(dateResponseFormat)
                                ),
                                justificationEndDate: new Date(
                                    moment(
                                        response.data?.dataLimiteJustificativa
                                    ).format(dateResponseFormat)
                                ),
                                approvalEndDate: new Date(
                                    moment(
                                        response.data?.dataLimiteAprovacao
                                    ).format(dateResponseFormat)
                                ),
                                insertedPersonName:
                                    response.data?.nomeQuemInseriu,
                                insertedPersonRegistration:
                                    response.data?.matriculaQuemInseriu,
                                updatedAt: new Date(
                                    moment(response.data?.updated).format(
                                        dateResponseFormat
                                    )
                                ),
                                isLoaded: true,
                            };

                        const tempHoliday = params?.find(
                            (item) =>
                                item.id === idHoliday &&
                                item.type === "GESTAO_ATIVIDADES"
                        );

                        if (tempHoliday) setHoliday(tempHoliday);
                        if (tempHoliday?.start) {
                            setDatesHoliday(
                                parseISO(tempHoliday?.start).toLocaleDateString(
                                    "pt-BR",
                                    {
                                        weekday: "long",
                                        month: "long",
                                        day: "numeric",
                                    }
                                )
                            );
                        }
                        setActivityManagementDetails(
                            newActivityManagementDateDetails
                        );
                    }
                } else {
                    const tempHoliday = params?.find(
                        (item) =>
                            item.id === idHoliday &&
                            item.type !== "ABONO_ADMINISTRACAO"
                    );
                    if (
                        tempHoliday?.type === "M" &&
                        tempHoliday?.campus &&
                        tempHoliday?.title
                    ) {
                        tempHoliday.title = tempHoliday.title.substring(
                            0,
                            tempHoliday.title.length -
                                tempHoliday.campus.length -
                                3
                        );
                    }
                    if (tempHoliday) setHoliday(tempHoliday);
                    if (tempHoliday?.start) {
                        setDatesHoliday(
                            parseISO(tempHoliday?.start).toLocaleDateString(
                                "pt-BR",
                                {
                                    weekday: "long",
                                    month: "long",
                                    day: "numeric",
                                }
                            )
                        );
                    }
                }
            }
        }
        getData();
    }, [open]);

    const modalSaveHoliday = (
        <ModalSaveHoliday
            open={openModalSaveHoliday}
            onClose={handleCloseModalSaveHoliday}
            params={holiday}
            abono={abono}
            gestaoAtividades={activityManagementDetails}
            refresh={async () => {}}
        />
    );

    const DialogQuestionDelete = (
        <DialogMessage
            show={openDialogQuestionDelete}
            onClose={handleCloseDialogQuestionDelete}
            type="question"
            title="Deseja excluir o parâmetro selecionado?"
            textButton="Sim"
            textButtonClose="Não"
        />
    );

    const DialogSuccess = (
        <DialogMessage
            type="success"
            show={Boolean(successMessage)}
            title={successMessage}
            onClose={handleCloseDialogSuccess}
        />
    );

    const DialogError = (
        <DialogMessage
            type="error"
            show={Boolean(errorMessage)}
            title={errorMessage}
            onClose={handleCloseDialogError}
        />
    );

    const openDeleteDialog = () => {
        setOpenDialogQuestionDelete(true);
        setShowDialog(false);
    };

    const isDateBeforeToday = (date: string | undefined): boolean => {
        if (date === undefined) {
            return false;
        }

        const [year, month, day] = date.split("-");
        const targetDate = new Date(
            Number(year),
            Number(month) - 1,
            Number(day)
        );
        const today = new Date();

        return DateUtils.isDateBefore(targetDate, today);
    };

    const dialogClass = `${showDialog ? "visible-dialog" : "hidden-dialog"}`;

    const showInformation = (
        <ModalInfoManagementActivity
            id={activityManagementDetails.id}
            referenceStartDate={activityManagementDetails.referenceStartDate}
            referenceEndDate={activityManagementDetails.referenceEndDate}
            justificationEndDate={
                activityManagementDetails.justificationEndDate
            }
            approvalEndDate={activityManagementDetails.approvalEndDate}
            insertedPersonRegistration={
                activityManagementDetails.insertedPersonRegistration
            }
            insertedPersonName={activityManagementDetails.insertedPersonName}
            updatedAt={activityManagementDetails.updatedAt}
            isLoaded={activityManagementDetails.isLoaded}
            open={showInfoManagement}
            onClose={handleCloseModalInformation}
        />
    );

    return (
        <>
            <Dialog
                openModal={open}
                onHide={onClose}
                className={dialogClass}
                size="width-379"
            >
                <Row className="mb-2">
                    <Col
                        xs="2"
                        style={{
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                            marginBottom: "15px",
                        }}
                    >
                        <div
                            style={{
                                width: "16px",
                                height: "16px",
                                background: holiday.color,
                                borderRadius: "2px",
                            }}
                        />
                    </Col>
                    <Col
                        xs="10"
                        style={{
                            textAlign: "initial",
                            fontWeight: "700",
                            fontSize: "24px",
                        }}
                    >
                        <Row className="mb-3">
                            <Col>{holiday.title}</Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mb-4">
                    <Col xs="2">
                        <CalendarIcon
                            style={{ fill: "#404040", paddingLeft: "0px" }}
                        />
                    </Col>
                    <Col
                        xs="10"
                        style={{
                            textAlign: "initial",
                            fontWeight: "400",
                            fontSize: "15px",
                        }}
                    >
                        <Row className="mb-3">
                            <Col>{datesHoliday}</Col>
                        </Row>
                        <Row className="mb-1">
                            <Col>{holiday.title}</Col>
                        </Row>
                        <Row className="mb-1">
                            <Col>{holiday.campus || ""}</Col>
                        </Row>
                        <Row className="mb-1">
                            <Col>{holiday.description}</Col>
                        </Row>
                        {type === "GESTAO_ATIVIDADES" &&
                            activityManagementDetails.isLoaded && (
                                <>
                                    <Row className="mb-1">
                                        <Col>Incluído/Editado por:</Col>
                                    </Row>
                                    <Row className="mb-1">
                                        <Col>
                                            {`Matrícula:
                                            ${activityManagementDetails.insertedPersonRegistration}`}
                                        </Col>
                                    </Row>
                                    <Row className="mb-1">
                                        <Col>
                                            {`Nome:
                                            ${activityManagementDetails.insertedPersonName}`}
                                        </Col>
                                    </Row>
                                    <Row className="mb-1">
                                        <Col>
                                            {`Data:
                                            ${moment(
                                                activityManagementDetails.updatedAt
                                            ).format(dateFormat)}`}
                                        </Col>
                                    </Row>
                                </>
                            )}
                    </Col>
                </Row>
                {!readonly && (
                    <Row
                        className="mb-3"
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <DefaultButtonLink
                            style={{ width: "130px" }}
                            onClick={() => {
                                setShowDialog(false);
                                setOpenModalSaveHoliday(true);
                            }}
                        >
                            <EditIcon style={{ marginRight: 5 }} />
                            Editar
                        </DefaultButtonLink>
                        <DefaultButtonLink
                            style={{ width: "130px" }}
                            onClick={() => {
                                setShowDialog(false);
                                openDeleteDialog();
                            }}
                        >
                            <DeleteIcon style={{ marginRight: 5 }} />
                            Excluir
                        </DefaultButtonLink>
                    </Row>
                )}
                <StyledCenterDiv style={{ flexDirection: "column" }}>
                    {type === "GESTAO_ATIVIDADES" &&
                        isDateBeforeToday(holiday?.start) && (
                            <DefaultButtonLink
                                onClick={() => {
                                    setShowDialog(false);
                                    setShowInfoManagement(true);
                                }}
                            >
                                Visualizar Informações
                            </DefaultButtonLink>
                        )}
                    <StyledContainerButton>
                        <BtnPrimary onClick={onClose}>Ok</BtnPrimary>
                    </StyledContainerButton>
                </StyledCenterDiv>
            </Dialog>
            {successMessage && DialogSuccess}
            {errorMessage && DialogError}
            {openDialogQuestionDelete && DialogQuestionDelete}
            {openModalSaveHoliday && modalSaveHoliday}
            {showInfoManagement && showInformation}
        </>
    );
};

export default ModalDetailHoliday;
